export default "__VITE_ASSET__AXntanRu__"